/**
 * For Norrland and Norrland Plus we need to block ability to select
 * duplex mullion type when we also have laminated glass inside or outside.
 */
class DuplexMullionRulesService {
    constructor() {
        this.serieNamesWithRuleEnabled = [
            'Norrland',
            'Norrland Plus',
        ];
        this.laminatedGlassSafetyIds = [
            3,
            4,
        ];
    }

    areConditionsMeet(selectedSerie, selectedInsideGlass, selectedOutsideGlass) {
        if (!this.isProductWithMatchingSerie(selectedSerie)) {
            return false;
        }
        if (!this.isLaminatedGlassSelected(selectedInsideGlass, selectedOutsideGlass)) {
            return false;
        }
        return true;
    }

    isLaminatedGlassSelected(selectedInsideGlass, selectedOutsideGlass) {
        if (
            this.laminatedGlassSafetyIds.find(safetyId => safetyId === selectedInsideGlass.attributes.glassSafetyId) ||
            this.laminatedGlassSafetyIds.find(safetyId => safetyId === selectedOutsideGlass.attributes.glassSafetyId)
        ) {
            return true;
        }
        return false;
    }

    isProductWithMatchingSerie(selectedSerie) {
        if (this.serieNamesWithRuleEnabled.find(serieName => serieName === selectedSerie.attributes.name)) {
            return true;
        }
        return false;
    }
}

export default angular.module('duplexMullionRulesService', [])
    .service('duplexMullionRulesService', DuplexMullionRulesService)
    .name;